/* src/app/views/display/components/edit-display/edit-display-menu-details/edit-display-menu-details.component.scss */
/*# sourceMappingURL=edit-display-menu-details.component.css.map */
